module.exports = __webpack_public_path__ + "static/media/HomeStoryImage1.825e4caf.jpg";